// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2UhqF","info":"PatientInfo_info__a3kah"};